module.exports = __webpack_public_path__ + "static/img/7.9be70ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/image/7.jpg
// module id = zYMp
// module chunks = 0